<template>
  <div class="verified">
    <SharedRmTooltip
      placement="top"
      :triggers="['hover', 'focus']"
      :class="hasPaymentMethod ? 'success' : ''"
    >
      <RmBtn
        color="super-light"
        class="icon"
      >
        <PaymentCard :active="hasPaymentMethod" />
      </RmBtn>
      <template #popper>
        {{ hasPaymentMethod ? $t('user.paymentCard.verifed.success') : $t('user.paymentCard.verifed.error') }}
      </template>
    </SharedRmTooltip>
    <SharedRmTooltip
      placement="top"
      :triggers="['hover', 'focus']"
      :class="isPhoneConfirmed ? 'success' : ''"
    >
      <RmBtn
        color="super-light"
        class="icon"
      >
        <Phone :active="isPhoneConfirmed" />
      </RmBtn>
      <template #popper>
        {{ isPhoneConfirmed ? $t('user.phone.verifed.success') : $t('user.phone.verifed.error') }}
      </template>
    </SharedRmTooltip>

    <SharedRmTooltip
      placement="top"
      :triggers="['hover', 'focus']"
      :class="isEmailConfirmed ? 'success' : ''"
    >
      <RmBtn
        color="super-light"
        class="icon"
      >
        <Email :active="isEmailConfirmed" />
      </RmBtn>
      <template #popper>
        {{ isEmailConfirmed ? $t('user.email.verifed.success') : $t('user.email.verifed.error') }}
      </template>
    </SharedRmTooltip>

  </div>
</template>

<script>
import Email from '~/components/user/verified/email.vue'
import PaymentCard from '~/components/user/verified/payment_card.vue'
import Phone from '~/components/user/verified/phone.vue'
// import Passport from '~/components/user/verified/passport.vue'
import RmBtn from '~/components/shared/rm_btn.vue'

export default {
  components: {
    Email,
    Phone,
    PaymentCard,
    // Passport,
    RmBtn,
  },
  props: {
    hasPaymentMethod: {
      type: Boolean,
      default: false,
    },
    isPhoneConfirmed: {
      type: Boolean,
      default: false,
    },
    isEmailConfirmed: {
      type: Boolean,
      default: false,
    },
    hasPrivateInfo: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
  .verified
    @apply flex flex-row
    .icon
      @apply h-8 w-8 mr-2 flex justify-center items-center min-h-0
      border-radius: 9.6px
</style>
